"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAAS_LIVEROOM_ID = void 0;
var SAAS_LIVEROOM_ID = 'WK_SAAS_LIVEROOM_ID';
exports.SAAS_LIVEROOM_ID = SAAS_LIVEROOM_ID;


//////////////////
// WEBPACK FOOTER
// ./~/@weike/services/lib/constants/saas.js
// module id = 333
// module chunks = 6